(function () {
  if (customElements.get('wedding-color-palette')) return;
  const mainFor = palette => [...document.querySelectorAll('[id^="ProductInfo-"] wedding-color-palette')].find(el => el.dataset.productId === palette.dataset.productId);
  const selected = palette => palette?.querySelector('[data-wcp-choice]:checked')?.value || '';
  function sync(palette, value) {
    document.querySelectorAll('wedding-color-palette').forEach(peer => {
      if (peer.dataset.productId !== palette.dataset.productId) return;
      peer.querySelectorAll('[data-wcp-choice]').forEach(input => { input.checked = input.value === value; });
      const name = peer.querySelector('[data-wcp-name]');
      if (name) name.textContent = value || 'Choose color';
      const error = peer.querySelector('[data-wcp-error]');
      if (error && value) error.hidden = true;
      const trigger = peer.closest('.product__popup')?.querySelector('.bfc-trigger');
      if (trigger) {
        trigger.querySelector('span').textContent = value || 'Choose color';
        trigger.setAttribute('aria-label', 'Choose color, current color: ' + (value || 'none'));
      }
    });
  }
  class WeddingColorPalette extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      queueMicrotask(() => {
        if (!this.isConnected) return;
        sync(this, selected(mainFor(this) || this));
        this.addEventListener('change', event => {
          if (!event.target.matches('[data-wcp-choice]')) return;
          sync(this, event.target.value);
          const main = mainFor(this)?.closest('[id^="ProductInfo-"]');
          // Reuse the native form's property/fee synchronization without changing production mode.
          main?.querySelector('[data-bnd-mode]:checked')?.dispatchEvent(new Event('change', {bubbles: true}));
        });
      });
    }
  }
  customElements.define('wedding-color-palette', WeddingColorPalette);
  document.addEventListener('submit', event => {
    if (!event.target.matches('form[data-type="add-to-cart-form"]')) return;
    const popup = event.target.closest('.product__popup');
    const info = popup ? document.getElementById('ProductInfo-' + popup.dataset.sectionId) : event.target.closest('[id^="ProductInfo-"]');
    const palette = info?.querySelector('wedding-color-palette');
    if (!palette || selected(palette)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    palette.querySelector('[data-wcp-error]').hidden = false;
    palette.scrollIntoView({behavior: 'smooth', block: 'center'});
    palette.querySelector('[data-wcp-choice]')?.focus({preventScroll: true});
  }, true);
})();
